import ManageLessonDecksPage from './ManageLessonDecksPage'
export default ManageLessonDecksPage;